export default {
  /**
   * 只能输入大于0的正整数（不能以0开头）
   * @param {string} value
   * @returns {string | number} 返回空字符或数字
   */
  integerFn(value) {
    let reg = /[^0-9.]/g;
    if (value) {
      return value.replace(reg,'');
    } else {
      return "";
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/limit.js